import { Typography } from "@mui/material";

// Estilo padrão (agendamentos e demais telas)
const defaultStyle: any = {
  text: {
    cancelled: "Cancelado",
    proposed: "Pendente",
    pending: "Pendente",
    arrived: "Confirmado",
    booked: "Confirmado",
    valid: "Ativo",
    expired: "Expirado",
    stopped: "Interrompido",
    active: "Solicitado",
    draft: "Solicitado",
    completed: "Finalizado",
    result: "Realizado",
  },
  backgroundColor: {
    cancelled: "error400.main",
    stopped: "neutral300.main",
    proposed: "neutral300.main",
    pending: "neutral300.main",
    arrived: "primary300.main",
    booked: "primary300.main",
    result: "primary300.main",
    valid: "primary300.main",
    expired: "neutral300.main",
    draft: "warning300.main",
    active: "warning300.main",
    completed: "none",
  },
};

// Estilo do manager de questionários (ativo verde, rascunho cinza, arquivado azul claro)
const questionnaireStyle: any = {
  text: {
    ...defaultStyle.text,
    active: "Ativo",
    draft: "Rascunho",
    unknown: "Arquivado",
  },
  backgroundColor: {
    ...defaultStyle.backgroundColor,
    draft: "neutral300.main",
    active: "success300.main",
    unknown: "primary100.main",
  },
};

export type StatusRowVariant = "default" | "questionnaire";

export interface StatusRowProps {
  status: string;
  variant?: StatusRowVariant;
}

export function StatusRow({ status, variant = "default" }: StatusRowProps) {
  const style = variant === "questionnaire" ? questionnaireStyle : defaultStyle;

  return (
    <Typography
      sx={{
        color: "neutral1000.main",
        bgcolor: style.backgroundColor[status] ?? "neutral200.main",
        p: "3px",
        borderRadius: "20px",
      }}
      fontWeight={400}
      textAlign="center"
    >
      {style.text[status] ?? status}
    </Typography>
  );
}
